interface ErrorBannerProps {
  message: string;
  className?: string;
}

export function ErrorBanner({ message, className = "mb-4" }: ErrorBannerProps) {
  return (
    <div
      className={`bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 ${className}`}
    >
      <p className="text-red-700 dark:text-red-400">{message}</p>
    </div>
  );
}
